import {Modal, ScrollView, View} from "react-native";
import MainStyle from "../../MainStyle";
import Div from "../lib/Div";
import P from "../lib/P";
import FontAwesome5 from "@expo/vector-icons/FontAwesome5";
import Btn from "../components/Btn";
import React from "react";
import {SavedCardType} from "../types";

type Props = { card?: SavedCardType, onClose: (cardUid?: string) => void };

const DeleteCardModal = (props: Props) => {
  const {card} = props;

  return (
    <Modal animationType="fade" transparent visible={!!card?.cardUid} statusBarTranslucent={false}
           hardwareAccelerated={false} onRequestClose={() => props.onClose()}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
        <ScrollView contentContainerStyle={MainStyle.flex1}>
          <Div minH="100%" alignItems="center" justifyContent="center">
            <Div bg="#131314" w={343} rounded={16} overflow="hidden">
              <Div position="relative" bg="#252526" justifyContent="center">
                <P fontFamily="DavisSans-Medium" ta="center" lh={48}>Delete Card</P>
                <FontAwesome5
                  name="times" size={28} color="white" style={[MainStyle.absolute, MainStyle.r_10]}
                  onPress={props.onClose}
                />
              </Div>

              <P fontFamily="DavisSans-Regular" mx={16} ta="center" mt={24} mb={30}>
                Are you sure want to delete card ending in <P
                fontFamily="DavisSans-Medium">{card?.cardMaskedNumber.slice(-8)}?</P>
              </P>

              <Btn mb={30} bg="#C73232" rounded={4} onPress={() => props.onClose(card?.cardUid)} mx={16}>
                <P lh={56} ta="center" fontFamily="DavisSans-Medium" color="white">Delete Card</P>
              </Btn>

              <Btn mb={24} onPress={() => props.onClose()}>
                <P ta="center" textDecorationLine="underline" fontFamily="DavisSans-Regular" color="white" lh={24}>
                  Back
                </P>
              </Btn>
            </Div>
          </Div>
        </ScrollView>
      </View>
    </Modal>
  );
};

export default DeleteCardModal;
